import IQueries from '@/interfaces/IQueries';

// Path with parameters
const palmLines: IQueries = {
    palmLinesList: {
        path: '/astrology/palm_lines',
        method: 'GET'
    },
    palmLineCreate: {
        path: '/astrology/palm_lines',
        method: 'POST'
    },
    palmLineDetail: {
        path: '/astrology/palm_lines/',
        method: 'GET'
    },
    palmLineUpdate: {
        path: '/astrology/palm_lines/',
        method: 'PUT'
    },

    palmLineTypes: {
        path: '/astrology/palm_line_types',
        method: 'GET'
    },
    palmLineSides: {
        path: '/astrology/palm_line_sides',
        method: 'GET'
    }
};

export default palmLines;
